import { ColumnConfig, OrderDetailsReportsColumnKey } from '../../model';

export const orderDetailsReportConfig: Record<
  OrderDetailsReportsColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S.No',
  },
  orderDate: {
    name: 'Ordered Date',
    sortField: 'orderDate',
  },
  orderNumber: {
    name: 'Order Number',
    sortField: 'orderId',
  },
  orderStatus: {
    name: 'Order Status',
    isComponent: true,
  },
  customerName: {
    name: 'Customer Firm Name',
    sortField: 'customerName',
  },
  totalSku: {
    name: 'Total SKU',
    sortField: 'totalLineItems',
    alignment: 'flex-end',
  },
  totalOrderValue: {
    name: 'Total Order Value',
    sortField: 'orderValue',
    alignment: 'flex-end',
  },
  cfaName: {
    name: 'CFA Name',
    sortField: 'cfaname',
  },
  salesrepName: {
    name: 'Salesman Name',
  },
};
